import { memo, useEffect, useState } from 'react';

import { Alert } from 'shared/Houston';
import If from 'shared/If';
import { enAnnouncementType } from 'types/enums';
import { ITextAnnouncement } from 'types/interfaces';
import { checkCookies } from 'utils/Cookies';

import { Container } from './styles';

interface IProps extends ITextAnnouncement {
  id: string;
}

enum enTypeToHouston {
  INFO = 'info',
  POSITIVE = 'success',
  NEGATIVE = 'error',
  WARNING = 'warning'
}

const hashMap = {
  [enAnnouncementType.POSITIVE]: enTypeToHouston.POSITIVE,
  [enAnnouncementType.NEGATIVE]: enTypeToHouston.NEGATIVE,
  [enAnnouncementType.WARNING]: enTypeToHouston.WARNING,
  [enAnnouncementType.INFORMATIVE]: enTypeToHouston.INFO
};

const TextAnnouncement: React.FC<IProps> = ({ type, id, text, title = '' }) => {
  const [isShow, setIsShow] = useState(false);

  useEffect(() => {
    if (!checkCookies()) {
      return;
    }

    setIsShow(!localStorage.getItem(id));
  }, [id]);

  if (!text || !isShow) {
    return null;
  }

  const closeAlert = () => {
    localStorage.setItem(id, '1');
    setIsShow(false);
  };

  return (
    <Container>
      <Alert type={hashMap[type]} onClose={closeAlert}>
        <If condition={title}>
          <h3 dangerouslySetInnerHTML={{ __html: title }} />
        </If>
        <div dangerouslySetInnerHTML={{ __html: text }} />
      </Alert>
    </Container>
  );
};

export default memo(TextAnnouncement);
